export interface ScannedProduct {
  barcode: string;
  sku: string;
  imageUrl?: string;
  location: string;
  availableQty: string;
  batch: string;
  expiry: string;
}

export interface ActionItem {
  id: string;
  label: string;
  icon: string;
  color: string;
}

/**
 * Static action grid — these are navigation buttons, not data,
 * so they remain hardcoded here as part of the UI configuration.
 */
export const actionItems: ActionItem[] = [
  { id: 'pick-pack', label: 'Pick & Pack Product', icon: 'pickPack', color: '#3B82F6' },
  { id: 'receiving', label: 'Receiving', icon: 'receiving', color: '#16A34A' },
  { id: 'report-oos', label: 'Report Out of Stock', icon: 'outOfStock', color: '#EF4444' },
  { id: 'return', label: 'Return', icon: 'return', color: '#7C3AED' },
  { id: 'report-damaged', label: 'Report Damaged', icon: 'damaged', color: '#F97316' },
  { id: 'transfer', label: 'Transfer', icon: 'transfer', color: '#6B7280' },
  { id: 'view-stock', label: 'View Stock Details', icon: 'viewStock', color: '#1F2937' },
];
